import { FiStar } from 'react-icons/fi';

const StarRating = ({ rating, maxRating = 5, size = 'md', showNumber = false, onRatingChange = null, interactive = false }) => {
    const sizes = {
        sm: 'text-sm',
        md: 'text-xl',
        lg: 'text-2xl',
        xl: 'text-3xl'
    };

    const sizeClass = sizes[size] || sizes.md;

    const handleStarClick = (index) => {
        if (interactive && onRatingChange) {
            onRatingChange(index + 1);
        }
    };

    return (
        <div className="flex items-center gap-1">
            <div className="flex">
                {[...Array(maxRating)].map((_, index) => {
                    const isFilled = index < Math.floor(rating);
                    const isHalfFilled = index < rating && index >= Math.floor(rating);

                    return (
                        <div 
                            key={index} 
                            className={`relative ${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : ''}`}
                            onClick={() => handleStarClick(index)}
                        >
                            {/* Background star (gray) */}
                            <FiStar className={`${sizeClass} text-gray-300`} />
                            
                            {/* Filled star */}
                            {isFilled && (
                                <FiStar 
                                    className={`${sizeClass} text-yellow-400 absolute top-0 left-0`} 
                                    fill="currentColor"
                                />
                            )}
                            
                            {/* Half-filled star */}
                            {isHalfFilled && (
                                <div className="absolute top-0 left-0 overflow-hidden" style={{ width: `${(rating - index) * 100}%` }}>
                                    <FiStar 
                                        className={`${sizeClass} text-yellow-400`} 
                                        fill="currentColor"
                                    />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
            {showNumber && (
                <span className="text-sm text-gray-600 ml-1">
                    {rating.toFixed(1)}
                </span>
            )}
        </div>
    );
};

export default StarRating;
